<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.70703 2.58563L15.707 10.5856C16.4881 11.3667 16.4881 12.633 15.707 13.4141L7.70703 21.4141L7.70703 18.5856L14.2928 11.9998L7.70703 5.41406L7.70703 2.58563Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionRightIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
</script>
